module.exports = __webpack_public_path__ + "static/img/safari.30c8198.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/safari.png
// module id = 3BcM
// module chunks = 1